import React, { Component, Fragment } from 'react';
import { ErrorMessage, Field, Form, Formik } from "formik";
import { Trans, withTranslation } from 'react-i18next';
import SubHeader from "./SubHeader";
import Header from "./Header";
import SecondHeader from "./SecondHeader";
import Loading from "./Loading";
import AppContext from "../../../contexts/AppContext";
import { Checkbox, TextField } from "../../Fields";

class ContactsForm extends Component {

    static contextType = AppContext;

    constructor(props) {
        super(props);

        this.state = {
            disabled: true,
            step_count: 3,
            current_step: 1,
            data: {
                first_name: '',
                last_name: '',
                email: '',
                phone: '',
                personal_code: '',
                incomes: '',

                amount_cl: '',
                amount_mortgage: '',
                amount_other: '',

                knows_bonus_code: false,
                bonus_code: '',
                knows_about_future_financial_changes: false,
            },
            has_liabilities: false,
            knows_about_future_financial_changes: false,
            redirectToNextStep: false,
            gtmEventSent: false,
        };

        this.renderForm = this.renderForm.bind(this);
        this.handleAgreementChange = this.handleAgreementChange.bind(this);
        this.handleOptionChange = this.handleOptionChange.bind(this);
        this.handleLiabilityChange = this.handleLiabilityChange.bind(this);

        gtm.sendEvent('base', {
            actionField: { step: 1 , action: 'contactDetails'},
            event: 'checkoutunregistered1',
            products: {
                price: props.suggestion.amount,
                variant: props.suggestion.term,
                product_code: props.suggestion.product,
                product_type: props.suggestion.type
            },
            pageTitle: 'Registration 1/4, contact details'
        });
    }

    handleOptionChange(changeEvent) {
        this.setState({
            knows_about_future_financial_changes: changeEvent.target.value === 'yes'
        });
        if (changeEvent.target.value === 'yes') {
            document.querySelector(`#incomes`)?.focus();
        }
    }

    handleLiabilityChange(changeEvent) {
        this.setState({ has_liabilities: changeEvent.target.checked })
    }

    handleAgreementChange(changeEvent) {
        this.setState({ disabled: !changeEvent.target.checked })
    }

    renderForm(props) {

        const { suggestion } = this.props;
        const { knows_about_future_financial_changes, has_liabilities } = this.state;

        return (<Fragment>

                {this.props.suggestion.type == 'IS' &&
                    <div className="col-12 mt-5 px-0">
                        <div className="alert alert-success fade show" role="alert">
                            <div className="row">
                                <div className="col-12 col-lg-8 offset-lg-1 offset-xl-2">
                                    <p className="mb-0">
                                        Toliau pildydamas paraišką, patvirtinu, kad paskolos suma bus naudojama atsinaujinančios energijos šaltiniams bei prireikus, galėsiu tai įrodyti nuomos, įrengimo ar pirkimo dokumentais.
                                        </p>
                                </div>
                            </div>
                        </div>
                    </div>
                }

                <Form className="form form-layout mt-5">

                    <div className="container form-layout__2-col">
                        <div className="form-group  col-md-6 col-lg-6">
                            <label className="form-label"
                                   htmlFor="first_name">{this.props.t('forms.first_name')}</label>
                            <Field autoFocus={true}
                                   type="text"
                                   name="first_name"
                                   id="first_name"
                                   disabled={props.isSubmitting}
                                   className={'form-control' + (props.errors.first_name && props.touched.first_name ? ' is-invalid' : '')}/>
                            <ErrorMessage name="first_name" component="div" className="invalid-feedback"/>
                        </div>

                        <div className="form-group col-md-6 col-lg-6">
                            <label className="form-label" htmlFor="last_name">{this.props.t('forms.last_name')}</label>
                            <Field type="text" name="last_name" id="last_name"
                                   disabled={props.isSubmitting}
                                   className={'form-control' + (props.errors.last_name && props.touched.last_name ? ' is-invalid' : '')}/>
                            <ErrorMessage name="last_name" component="div" className="invalid-feedback"/>
                        </div>

                        <div className="form-group col-md-6 col-lg-6">
                            <label className="form-label"
                                   htmlFor="personal_code">{this.props.t('forms.personal_code')}</label>
                            <Field
                                type="text"
                                name="personal_code"
                                id="personal_code"
                                disabled={props.isSubmitting}
                                className={'form-control' + (props.errors.personal_code && props.touched.personal_code ? ' is-invalid' : '')}
                            />
                            <ErrorMessage name="personal_code" component="div" className="invalid-feedback"/>
                        </div>

                        <div className="form-group col-md-6 col-lg-6">
                            <label className="form-label" htmlFor="email">{this.props.t('forms.email')}</label>
                            <Field type="text" name="email" id="email"
                                   disabled={props.isSubmitting}
                                   autoComplete="email"
                                   className={'form-control' + (props.errors.email && props.touched.email ? ' is-invalid' : '')}/>
                            <ErrorMessage name="email" component="div" className="invalid-feedback"/>
                        </div>

                        <div className="form-group col-md-6 col-lg-6">
                            <label htmlFor="phone">{this.props.t('forms.phone')}</label>
                            <div className="input-group">
                                <div className="input-group-prepend">
                                    <div className="input-group-text">+370</div>
                                </div>
                                <Field type="text"
                                       name="phone"
                                       id="phone"
                                       disabled={props.isSubmitting}
                                       className={'form-control' + (props.errors.phone && props.touched.phone ? ' is-invalid' : '')
                                       }/>
                            </div>
                            <ErrorMessage name="phone" component="div" className="invalid-feedback definitely-show"/>
                        </div>

                        <div className="form-group  col-md-6 col-lg-6">
                            <label className="form-label" htmlFor="incomes">{this.props.t('forms.monthly_income')}</label>
                            <Field type="number" name="incomes" id="incomes" disabled={props.isSubmitting}
                                   className={'form-control' + (props.errors.incomes && props.touched.incomes ? ' is-invalid' : '')}
                            />
                            <ErrorMessage name="incomes" component="div" className="invalid-feedback"/>
                        </div>

                        <div className="form-group col-12">
                            <div className="custom-control custom-checkbox mt-3">
                                <input type="checkbox"
                                       id="customCheck1"
                                       className="custom-control-input"
                                       onChange={this.handleAgreementChange}
                                       checked={!this.state.disabled}/>
                                <label className="custom-control-label" htmlFor="customCheck1">
                                    <Trans i18nKey="forms.agreement">
                                        <span id="for-testing-agreement">Sutinku su </span>
                                        <a href="https://inbank.lt/documents/inbank/lt/lt/pdf/Principles_of_processing_client_data.pdf" target="_blank">Kliento duomenų tvarkymo principais</a>
                                        ir
                                        <a href="https://inbank.lt/documents/inbank/lt/lt/pdf/Terms_and_Conditions_of_Website_Use.pdf" target="_blank">svetainės
                                            naudojimosi taisyklėmis</a>
                                    </Trans>
                                </label>
                            </div>
                        </div>

                        <div className="col-12 mt-3">
                            <div className="mb-2">{this.props.t('forms.do_you_know')}</div>
                            <div className="d-flex">
                                <div className="form-group mr-4">
                                    <div className="custom-control custom-radio">
                                        <input type="radio"
                                               id="radiobuttonExample1"
                                               className="custom-control-input"
                                               value="yes"
                                               checked={knows_about_future_financial_changes}
                                               disabled={props.isSubmitting}
                                               onChange={this.handleOptionChange}
                                               onInput={this.props.handleFFChange}
                                        />
                                        <label className="custom-control-label"
                                               htmlFor="radiobuttonExample1">{this.props.t('forms.yes')}</label>
                                    </div>
                                </div>
                                <div className="form-group">
                                    <div className="custom-control custom-radio">
                                        <input type="radio" id="radiobuttonExample2"
                                               className="custom-control-input"
                                               value="no"
                                               checked={!knows_about_future_financial_changes}
                                               disabled={props.isSubmitting}
                                               onChange={this.handleOptionChange}
                                               onInput={this.props.handleFFChange}
                                        />
                                        <label className="custom-control-label"
                                               htmlFor="radiobuttonExample2">{this.props.t('forms.no')}</label>
                                    </div>
                                </div>
                            </div>
                        </div>
                        {knows_about_future_financial_changes &&
                            <div className="col-12  mb-4" style={{color: "#470A68"}}>
                                {this.props.t('forms.enter_expected_income')}
                            </div>
                        }

                        <div className="form-group col-12  mb-4">
                            <div className="custom-control custom-checkbox mt-3">
                                <input type="checkbox" className="custom-control-input" id="customCheck2"
                                       name="customCheck" checked={has_liabilities}
                                       disabled={props.isSubmitting}
                                       onChange={this.handleLiabilityChange}/>
                                <label className="custom-control-label" htmlFor="customCheck2">
                                    {this.props.t('forms.has_liabilities')}
                                    <i className="icons icon-question-circle" data-toggle="tooltip"
                                       data-placement="top" title={this.props.t('forms.liabilities_tooltip')}></i>
                                </label>
                            </div>
                        </div>

                        {has_liabilities &&
                            <div className="col-12 col-lg-4 col-md-6 liabilities-input">
                                <div className="form-group">
                                    <label htmlFor="amount_cl">{this.props.t('forms.your_credit_liabilities')}</label>
                                    <div className="input-group">
                                        <Field type="number" name="amount_cl" id="amount_cl" disabled={props.isSubmitting}
                                               className={'form-control' + (props.errors.amount_cl && props.touched.amount_cl ? ' is-invalid' : '')}/>
                                        <div className="input-group-append ">
                                            <div className="input-group-text bg-white border-left-0">
                                                {this.props.t('forms.eur_per_month')}
                                            </div>
                                        </div>
                                    </div>
                                    <ErrorMessage name="amount_cl" component="div"
                                                  className="invalid-feedback definitely-show"/>
                                </div>
                            </div>
                        }

                        {has_liabilities &&
                            <div className="col-12 col-lg-4 col-md-6 liabilities-input">
                                <div className="form-group">
                                    <label htmlFor="amount_mortgage">{this.props.t('forms.your_mortgage_liabilities')}</label>
                                    <div className="input-group">
                                        <Field type="number" name="amount_mortgage" id="amount_mortgage"
                                               disabled={props.isSubmitting}
                                               className={'form-control' + (props.errors.amount_mortgage && props.touched.amount_mortgage ? ' is-invalid' : '')}/>
                                        <div className="input-group-append ">
                                            <div className="input-group-text bg-white border-left-0">
                                                {this.props.t('forms.eur_per_month')}
                                            </div>
                                        </div>
                                    </div>
                                    <ErrorMessage name="amount_mortgage" component="div"
                                                  className="invalid-feedback  definitely-show"/>
                                </div>
                            </div>
                        }

                        {has_liabilities ? (
                                <div className="col-12 col-lg-4 col-md-6 liabilities-input">
                                    <div className="form-group">
                                        <label htmlFor="amount_other">{this.props.t('forms.your_other_liabilities')}</label>
                                        <div className="input-group">
                                            <Field type="number" name="amount_other" id="amount_other"
                                                   disabled={props.isSubmitting}
                                                   className={'form-control' + (props.errors.amount_other && props.touched.amount_other ? ' is-invalid' : '')}/>
                                            <div className="input-group-append ">
                                                <div className="input-group-text bg-white border-left-0">
                                                    {this.props.t('forms.eur_per_month')}
                                                </div>
                                            </div>
                                        </div>
                                        <ErrorMessage name="amount_other" component="div"
                                                      className="invalid-feedback  definitely-show"/>
                                    </div>
                                </div>)
                            : ''}


                        {has_liabilities &&
                            <p className="col-12 text-muted">{this.props.t('forms.liabilities_explanation')}</p>
                        }

                        {!suggestion.is_eshop &&
                            <div className="form-group col-12  mb-4">
                                <Checkbox name='knows_bonus_code'
                                          disabled={props.isSubmitting}
                                          label={this.props.t('forms.know_bonus_code')}
                                          {...props}
                                />
                            </div>
                        }

                        {props.values.knows_bonus_code &&
                            <div className="form-group col-12  mb-4">
                                <TextField name='bonus_code'
                                           disabled={props.isSubmitting}
                                           label={this.props.t('forms.bonus_code')}
                                           {...props}
                                />
                            </div>
                        }
                    </div>
                    <div className="form-group col-12 d-flex justify-content-center mt-3">
                        <button type="submit" className="btn btn-primary btn-lg"
                                disabled={props.isSubmitting || this.state.disabled}>
                            {this.props.t('forms.next')}
                        </button>
                    </div>
                </Form>
            </Fragment>
        );
    }

    render() {

        const { hasError } = this.context;

        return (
            <div>
                <Header title={this.props.t('step.registration')}/>

                <div className="section window-layout">
                    <div className="container frame">
                        <SubHeader title={this.props.t('substep.contacts')}
                                   step_count={this.state.step_count}
                                   current_step={this.state.current_step}/>

                        <div className="row">
                            {this.props.suggestion.loading && !hasError &&
                            <div className="form-layout mt-5">
                                <Loading/>
                            </div>
                            }

                            {!this.props.suggestion.loading &&
                                <Fragment>
                                    <SecondHeader suggestion={this.props.suggestion} />
                                    <Formik
                                        initialValues={this.props.data}
                                        render={this.renderForm}
                                        onSubmit={this.props.submitFunction}
                                        enableReinitialize={true}
                                        handleReset={(values, formikBag) => {
                                            console.log(values, formikBag)
                                        }}
                                    />
                                </Fragment>
                            }
                        </div>
                    </div>
                </div>
            </div>

        )
    }
}

export default withTranslation()(ContactsForm);
